import React from "react";
import styles from "./Section4.module.scss";

export const Section4 = function () {
  return (
    <section className={`${styles.container} cc--component-container`}>
      <div className={styles.container_wrapper}>
        <aside className={styles.container_aside}>
          <picture className="s3-bucket-image  " data-img-src="S3_bucket">
            <source
              media="(max-width: 767px)"
              srcSet="https://media.bootcampcdn.com/Columbia/landing/cyber/b5/img_further_m.jpg"
            />
            <source
              media="(min-width: 768px)"
              srcSet="https://media.bootcampcdn.com/Columbia/landing/cyber/b5/img_further.jpg"
            />
            <img
              decoding="async"
              loading="lazy"
              alt="Student at laptop"
              src="https://media.bootcampcdn.com/Columbia/landing/cyber/b5/img_further.jpg"
            />
          </picture>
        </aside>
        <main className={styles.container_main}>
          <h2 className={styles.headline}>Further Your Career</h2>
          <p>
            Our Career Engagement Network will help you apply the tools and knowledge you have learned to advance your
            career. We will help you optimize your <strong>resume and LinkedIn profile</strong>, prepare for{" "}
            <strong>interviews</strong>, and build your <strong>portfolio</strong>. You’ll also have access to free
            career resources throughout your professional life.
          </p>
        </main>
      </div>
    </section>
  );
};
